module.exports = __webpack_public_path__ + "static/media/400002_02.c445783d.png";